{
  "version": 1,
  "states": {
    "AL": {
      "phosphateProduct": "DAP",
      "phosphatePricePerTon": 956.83,
      "phosphateLbsPerTon": 920,
      "potashPricePerTon": 535.2,
      "dataClass": "Direct state survey"
    },
    "CO": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1083.17,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 664,
      "dataClass": "Regional survey (multi-state)"
    },
    "IA": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 940.71,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 493.38,
      "dataClass": "Direct state survey"
    },
    "ID": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1201.47,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 694,
      "dataClass": "Regional survey (multi-state)"
    },
    "IL": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 922,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 497.08,
      "dataClass": "Direct state survey"
    },
    "IN": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 845,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 460,
      "dataClass": "Standing default"
    },
    "MD": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1030,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 506.25,
      "dataClass": "Direct state survey"
    },
    "MS": {
      "phosphateProduct": "DAP",
      "phosphatePricePerTon": 645,
      "phosphateLbsPerTon": 920,
      "potashPricePerTon": 511.2,
      "dataClass": "Budget-derived (NOT a market price)"
    },
    "MT": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1083.17,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 664,
      "dataClass": "Regional survey (multi-state)"
    },
    "NC": {
      "phosphateProduct": "DAP",
      "phosphatePricePerTon": 987.5,
      "phosphateLbsPerTon": 920,
      "potashPricePerTon": 535,
      "dataClass": "Direct state survey"
    },
    "ND": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 834.8,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 456,
      "dataClass": "Budget-derived (NOT a market price)"
    },
    "NV": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1083.17,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 664,
      "dataClass": "Regional survey (multi-state)"
    },
    "OH": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 987,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 486,
      "dataClass": "Direct state survey"
    },
    "OK": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 941.63,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 492.05,
      "dataClass": "Direct state survey"
    },
    "OR": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1201.47,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 694,
      "dataClass": "Regional survey (multi-state)"
    },
    "PA": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 937,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 476.6,
      "dataClass": "Direct state survey"
    },
    "SC": {
      "phosphateProduct": "DAP",
      "phosphatePricePerTon": 893.33,
      "phosphateLbsPerTon": 920,
      "potashPricePerTon": 466.67,
      "dataClass": "Direct state survey"
    },
    "UT": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1083.17,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 664,
      "dataClass": "Regional survey (multi-state)"
    },
    "WA": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1201.47,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 694,
      "dataClass": "Regional survey (multi-state)"
    },
    "WY": {
      "phosphateProduct": "MAP",
      "phosphatePricePerTon": 1083.17,
      "phosphateLbsPerTon": 1040,
      "potashPricePerTon": 664,
      "dataClass": "Regional survey (multi-state)"
    }
  }
}
